import styles from "./Table.module.css";
// { title, edit, columns, children }
export function Table(props) {
  function Edit() {
    if (props?.edit) {
      return <th style={{ width: 10 }}>Ação</th>;
    }
    return null;
  }

  // function handleSort(index, key) {
  //   if (typeof props.onSort === "function") {
  //     props.onSort(index, key);
  //   }
  // }

  return (
    <table
      className={`${styles.table} ${props.className}`}
      id={props?.id}
      style={props.style}
    >
      <thead style={{ position: props.sticky ? "sticky" : "", top: 0, zIndex: 2 }}>
        {props?.title ? (
          <tr>
            <th
              colSpan={
                props?.edit ? props?.columns.length + 1 : props?.columns.length
              }
            >
              {props?.title}
            </th>
          </tr>
        ) : null}
        <tr>
          <Edit />
          {props?.columns.map((values, index) => {
            const isSorted = props.ordem?.coluna === values.key;
            const direction = props.ordem?.direcao;
            return (
              <th
                className={values.hiden ? styles.hiden : null}
                key={index}
                style={
                  (values.align ? { textAlign: values.align } : null,
                  props.onSort ? { cursor: "pointer" } : null)
                }
                onClick={
                  props.onSort ? () => props.onSort(index, values.key) : null
                }
              >
                <div className={styles.th}>
                  {values?.column}
                  {isSorted &&
                    props.onSort &&
                    (direction === "asc" ? (
                      <i class="fas fa-arrow-up" style={{ color: "white" }}></i>
                    ) : (
                      <i
                        class="fas fa-arrow-down"
                        style={{ color: "white" }}
                      ></i>
                    ))}
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>{props?.children}</tbody>
    </table>
  );
}
